import GetAppIcon from '@material-ui/icons/GetApp';
import PrintIcon from '@material-ui/icons/Print';
import { Button, PrintableAreaRef, StandardDialog } from '@roc/ui';
import { observer } from 'mobx-react';
import { useEffect, useRef } from 'react';
import { DownloadableQuoteHtml } from './downloadableQuoteHtml';
import { QuoteTypeStore } from '../../stores/quoteTypeStore';



interface Props {
  open?: boolean;
  onClose?: () => void;
  store: QuoteTypeStore;
  rateBuydownOptions: any[];
  displayOnlySelected?: boolean;
  swapRateToUse?: number;
}

export const DownloadableQuotesDialog = observer((props: Props) => {
  const { open, onClose, store, rateBuydownOptions, displayOnlySelected = false, swapRateToUse = undefined } = props;
  const downloadableLoanRatesRef = useRef<PrintableAreaRef>(null);

  const pricingOptions = displayOnlySelected ? [store.pricerSummaryStore.submittedPricingOption] : store.pricerSummaryStore.pricingOptions;

  useEffect(() => {
    if (open) {
      const loadLiquidityForQuote = async () => {
        await store.pricerSummaryStore.fetchLoanRatesPdfData(swapRateToUse);
        const freshPricingOptions = displayOnlySelected
          ? [store.pricerSummaryStore.submittedPricingOption]
          : store.pricerSummaryStore.pricingOptions;
        store.pricerSummaryStore.fetchLiquidityNeededForQuote(freshPricingOptions);
      };
      loadLiquidityForQuote();
    }
  }, [open]);

  const download = () => {
    const loanQuoteData = store.getLoanQuoteData();
    const documentName = `${loanQuoteData.propertyAddress} Quote.pdf`;
    downloadableLoanRatesRef.current.downloadAsPdf(documentName);
  };

  const print = async () => {
    const url = await downloadableLoanRatesRef.current.getPdfBlobUrl();
    const printWindow = window.open(url.toString(), '_blank');
    printWindow?.print();
  };

  const loanRatesData = store.pricerSummaryStore.loanRatesPdfData;

  const dialogActions = (
    <>
      <Button
        style={{ marginRight: '8px' }}
        testId="print-pdf"
        color="default"
        variant="contained"
        onClick={print}
        startIcon={<PrintIcon />}
      >
        Print
      </Button>
      <Button
        testId="download-pdf"
        color="primary"
        variant="contained"
        startIcon={<GetAppIcon />}
        onClick={download}
      >
        Download
      </Button>
    </>
  );

  return (
    <StandardDialog
      open={open}
      title="Loan Rates"
      maxWidth="md"
      handleClose={onClose}
      dialogActions={dialogActions}
      dialogContent={
        loanRatesData ? (
          <DownloadableQuoteHtml
            ref={downloadableLoanRatesRef}
            loanRatesData={loanRatesData}
            store={store}
            pricingOptions={pricingOptions}
          />
        ) : null
      }
    />
  );
})